import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CategoryiconsPage } from './categoryicons.page';

const routes: Routes = [
  {
    path: '',
    component: CategoryiconsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CategoryiconsPageRoutingModule {}
